<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs
                    v-model="tab"
                    color="darkGreen"
                    @update:model-value="init()"
                    >
                    <v-tab value="0" :class="{'font-weight-black': tab == '0'}">For Preparation</v-tab>
                    <v-tab value="prepared" :class="{'font-weight-black': tab == 'prepared'}">Prepared</v-tab>
                    <!-- <v-tab value="returned" :class="{'font-weight-black': tab == 'returned'}">Returned</v-tab> -->
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="tab == '0'" class="d-flex text-right flex-column" cols="12" md="4">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Create Pre-approved Workload
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.compliance="{ item }">
                                <div class="text-truncate" style="max-width: 200px;">
                                    {{ item.compliance.compliance_name }}
                                </div>
                            </template>
                            <template v-slot:item.submittedBy="{ item }">
                                <div>
                                    {{ item.file.submittedBy.fname }} {{ item.file.submittedBy.lname }}
                                </div>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <div>
                                    {{ formatDate(item.datecreated) }}
                                </div>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip :color="getWorkloadStatusColor(item)" class="text-caption">
                                    <span>{{ getWorkloadStatus(item) }}</span>
                                </v-chip>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showViewDialog(item)" size="small" variant="outlined" text="View" color="green-accent-4" elevation="2"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <WorkLoadPrepareDialog ref="WorkLoadPrepareDialog" @refresh="init()"/>
        <CreatePreApprovedWorkload ref="CreatePreApprovedWorkload" @refresh="init()"/>
    </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import WorkLoadPrepareDialog from '../Dialogs/WorkLoadPrepareDialog.vue';
import CreatePreApprovedWorkload from '../Dialogs/CreatePreApprovedWorkloadDialog.vue';

export default defineComponent({
    components: {
        WorkLoadPrepareDialog,
        CreatePreApprovedWorkload
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'faculty_name' },
                { title: 'Employment Status', align: 'start', sortable: true, key: 'employment_status' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Status', align: 'start', sortable: true, key: 'status' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            schoolYearData: [],
            schoolyear_id: null,
            selectedSchoolyear: null,

            smAndDown: false,
            
            tab: '0'
        }
    },
    methods: {
        init(){
            if(this.tab == '0'){
                this.loading = true
                const token = localStorage.getItem('aums-token')
                axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/findAllLoadByProgramAndSemesterSchoolyear/' + this.$store.state.user.program.id + '/' +  this.$store.state.semester_schoolyear.id + '/' + this.$store.state.user.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else{
                this.loading = true
                const token = localStorage.getItem('aums-token')
                axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/findAllLoadByProgramAndSemesterSchoolyear/' + this.$store.state.user.programId + '/' + this.$store.state.semester_schoolyear.id + '/' + this.$store.state.user.id + '/?status=' + this.tab,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        getWorkloadStatus(item) {
            if (!item.prepared_status) return "For Preparation";
            if (item.prepared_status === "prepared" && !item.recommending_approval_status) return "For Recommending Approval";
            if (item.recommending_approval_status === "recommended" && !item.pre_approved_status) return "For Pre-Approval";
            if (item.pre_approved_status === "pre-approved" && !item.approved_status) return "For Approval";
            if (item.approved_status === "approved") return "Approved";
            return "Unknown Status";
        },
        getWorkloadStatusColor(item) {
            if (!item.prepared_status) return "orange";
            if (item.prepared_status === "prepared" && !item.recommending_approval_status) return "blue";
            if (item.recommending_approval_status === "recommended" && !item.pre_approved_status) return "teal";
            if (item.pre_approved_status === "pre-approved" && !item.approved_status) return "purple";
            if (item.approved_status === "approved") return "green";
            return "gray";
        },
        showViewDialog(data){
            this.$refs.WorkLoadPrepareDialog.initView(data, this.tab)
        },
        showAddDialog(){
            this.$refs.CreatePreApprovedWorkload.initAdd(this.$store.state.user.programId)
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>